export enum ECommonMenuType {
  SETTINGS = 'SETTINGS',
  NOTIFICATIONS = 'NOTIFICATIONS',
  HELP = 'HELP',
  SIGN_OUT = 'SIGN_OUT',
}
